
define('ldsh!modules/accounts/users/modalCantCreate/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<!-- Modal Limites -->\n<div\n  class="modal fade"\n  id="modalLimitService"\n  tabindex="-1"\n  role="dialog"\n  aria-labelledby="modalLangLabel"\n  aria-hidden="true"\n>\n  <div class="modal-dialog modal-dialog-services">\n    <div class="modal-content">\n      <div class="modal-header">\n        <div class="close-wrapper">\n          <a class="close" data-dismiss="modal">\n            <i class="ri-close-line"></i>\n          </a>\n        </div>\n      </div>\n      <div class="modal-body modal-body-services">\n        <div class="alert alert-danger" role="alert">\n          ';
 var userName = me.get('NAME')[0],serviceName = 'MDirector'; ;
__p += '\n          <strong\n            class="i18n"\n            data-i18n="ACCOUNTS.USERS.LBL_SORRY"\n            data-i18n-options=\'{"userName": "' +
__e(userName ) +
'", "serviceName" : "' +
__e(serviceName ) +
'"}\'\n          > </strong>\n        </div>\n        <p>\n          <strong\n            class="i18n"\n            data-i18n="[html]ACCOUNTS.COMPANIES.LBL_GET_THE_MAX_SERVICES"\n            data-i18n-options=\'{"serviceName": "' +
__e(serviceName ) +
'"}\'\n          > </strong>\n        </p>\n      </div>\n    </div>\n  </div>\n</div>\n';

}
return __p
};});

